// announcements-layer/utils/query-keys.utils.ts
import type { AnnouncementListParams } from '../types/announcement'

/**
 * Stable TanStack Query keys for the announcements domain. The list key includes
 * the resolved filter params so changing a filter naturally drives a refetch,
 * while unread-count and detail stay independently cacheable/invalidatable.
 */
export const announcementsQueryKeys = {
  all: (locationId?: string) => ['announcements', locationId] as const,
  list: (locationId?: string, params?: AnnouncementListParams) => ['announcements', locationId, 'list', params ?? {}] as const,
  tablePage: (locationId?: string, params?: AnnouncementListParams, page?: number, limit?: number) =>
    ['announcements', locationId, 'table', params ?? {}, page, limit] as const,
  unreadCount: (locationId?: string) => ['announcements', locationId, 'unread-count'] as const,
  detail: (locationId?: string, id?: string) => ['announcements', locationId, 'detail', id] as const,
}
